import { render, staticRenderFns } from "./partnerContactsBox.vue?vue&type=template&id=7ae9f1e4&"
import script from "./partnerContactsBox.vue?vue&type=script&lang=ts&"
export * from "./partnerContactsBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports